<template>
    <div class="carousel-item active"
         v-if="slideActive === index"
         :style="{backgroundImage: 'url('+item.image+')'}">
        <div class="carousel-container">
            <div class="container">
                <h2 class="animate__animated animate__fadeInDown">{{ item.title }}</h2>
                <p class="animate__animated animate__fadeInUp">
                    {{ item.description }}
                </p>
                <router-link to="/pharmaplus/contact" class="btn-get-started scrollto animate__animated animate__fadeInUp">
                    Nous contacter
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CarouselItem",
        props:{
            item: {
                type: Object
            },
            index: {
                type: Number
            },
            slideActive: {
                type: Number
            },
        }
    }
</script>

<style lang="scss" scoped>
 //background-image: url(../../../../images/fond/Accueil1.jpg)
</style>